import React from 'react';

import { Navigate } from 'react-router-dom';

import { ENUM_ROLE_USER } from 'constants/enum';
import AppRoutes from 'routes/routes';

const PublicRoute = ({ element, isAuthenticated, role }) => {
  if (role === ENUM_ROLE_USER.ADMIN) {
    return isAuthenticated ? <Navigate to={AppRoutes.users} /> : element;
  } else {
    return isAuthenticated ? <Navigate to={AppRoutes.survey} /> : element;
  }
};

export default React.memo(PublicRoute);
